import { useRef } from "react";
import Table from "../../../components/tables/base";
import { Chart as ChartDOM } from "react-chartjs-2";
import { Chart as ChartJs } from "chart.js";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";

type Props = {
  data: any;
};

Chart.register(CategoryScale);

const PauliResult = ({ data }: Props) => {
  const chartRef = useRef<ChartJs>(null);

  return (
    <>
      <div>
        {!data.result ? (
          <span>
            <i>Belum ada jawaban</i>
          </span>
        ) : (
          <div className="w-full py-4">
            <strong>{data.name}</strong>
            <Table>
              <Table.Thead>
                <Table.Th className="text-center">Total Jawaban</Table.Th>
                <Table.Th className="text-center">Jumlah Salah</Table.Th>
                <Table.Th className="text-center">Puncak</Table.Th>
                <Table.Th className="text-center">Tinggi</Table.Th>
                <Table.Th className="text-center">Persentase Salah</Table.Th>
              </Table.Thead>
              <Table.Tbody>
                <Table.Tr>
                  <Table.Td className="text-center">
                    {data?.result?.total}
                  </Table.Td>
                  <Table.Td className="text-center">
                    {data?.result?.salah}
                  </Table.Td>
                  <Table.Td className="text-center">
                    {data?.result?.puncak}
                  </Table.Td>
                  <Table.Td className="text-center">
                    {data?.result?.tinggi}
                  </Table.Td>
                  <Table.Td className="text-center">
                    {data?.result?.salahPercent?.toFixed(2)}%
                  </Table.Td>
                </Table.Tr>
              </Table.Tbody>
            </Table>
          </div>
        )}

        <div className="mt-3 w-full">
          <ChartDOM
            type="line"
            ref={chartRef}
            data={{
              labels:
                data?.result?.timeIndex?.map(
                  (_: any, index: number) => `Menit ${index + 1}`
                ) || [],
              datasets: [
                {
                  label: "Jumlah per Menit",
                  data: data?.result?.timeIndex || [],
                  borderColor: "rgb(75, 192, 192)",
                  backgroundColor: "rgba(75, 192, 192, 0.2)",
                  tension: 0.1,
                },
                {
                  label: "Rata-rata",
                  data:
                    data?.result?.timeIndex?.map(
                      () =>
                        data?.result?.timeIndex?.reduce(
                          (a: number, b: number) => a + b,
                          0
                        ) / data?.result?.timeIndex?.length
                    ) || [],
                  borderColor: "rgb(255, 99, 132)",
                  backgroundColor: "rgba(255, 99, 132, 0.2)",
                  borderDash: [5, 5],
                },
              ],
            }}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  labels: {
                    font: {
                      size: 10,
                    },
                  },
                },
                title: {
                  display: true,
                  text: "Grafik Performa Pauli Test",
                },
              },
              scales: {
                y: {
                  type: "linear",
                  beginAtZero: true,
                  max: Math.max(...(data?.result?.timeIndex || [0])) + 10,
                  ticks: {
                    stepSize: 5,
                  },
                  title: {
                    display: true,
                    text: "Jumlah Jawaban",
                  },
                },
                x: {
                  title: {
                    display: true,
                    text: "Waktu (Menit)",
                  },
                },
              },
            }}
          />
        </div>
      </div>
    </>
  );
};

export default PauliResult;
